import React, { FC } from 'react';
import { NCFileBatchEventsMenuProps } from '@v2/pages/machines/common/components/Header/MachinesHeaderV2/types';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { isPhone } from '@helpers';
import { scale } from '@components/frame';
import { HEADER_MOBILE_GAP_BETWEEN_LEVELS } from '@v2/pages/common/constants/base.constants';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { NavLink } from './NavLink';
import { ScrollView } from 'react-native';

const NCFileBatchEventTypeMenu: FC<NCFileBatchEventsMenuProps> = ({ rowStyles, onPress, checkIsSelected, omitItems }) => {
  const { handleNavigateNcFileBatchEvents, activeNcFileBatchEventsSubScreenName } = useHandleNavigationMachinesHeader();

  const defaultMenuItems = Object.values(NcFileBatchEventType);
  const shouldUseDefaultMenuItems = !omitItems || !Array.isArray(omitItems) || omitItems.length === 0;
  const filteredMenuItems = shouldUseDefaultMenuItems ? defaultMenuItems : defaultMenuItems.filter((i) => !omitItems.includes(i));

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={[rowStyles, isPhone && { paddingBottom: scale(HEADER_MOBILE_GAP_BETWEEN_LEVELS) }]}
    >
      {filteredMenuItems.map((title) => {
        return (
          <NavLink
            key={title}
            title={title}
            selected={checkIsSelected ? checkIsSelected(title) : title === activeNcFileBatchEventsSubScreenName}
            onPress={() => (onPress ? onPress(title) : handleNavigateNcFileBatchEvents(title))}
          />
        );
      })}
    </ScrollView>
  );
};

export { NCFileBatchEventTypeMenu };
